import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="w-full bg-cream pt-16 pb-20 px-6 md:pt-24 md:pb-28" data-id="element-41">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-42">
        <FadeIn data-id="element-43">
          <span className="text-gold font-bold tracking-wider uppercase text-sm md:text-base mb-4 block" data-id="element-44">
            Atención Mujeres 45+
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-45">
            RECUPERA TU AGUDEZA MENTAL Y ELIMINA LA "NIEBLA" DE LA MENOPAUSIA EN
            SOLO 7 DÍAS
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-46">
          <h2 className="text-xl md:text-2xl text-charcoal-light font-sans font-medium max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-47">
            El Protocolo de Nutrición Cerebral de 10 minutos diseñado para
            despertar tu memoria y enfoque sin necesidad de hormonas ni
            fármacos.
          </h2>
        </FadeIn>

        <FadeIn delay={0.6} className="w-full max-w-md mx-auto" data-id="element-48">
          <Button className="w-full" onClick={() => {
          const el = document.getElementById('offer-section');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-49">
            ¡SÍ, QUIERO RECUPERAR MI CLARIDAD MENTAL HOY MISMO!
          </Button>
          <p className="text-sm text-charcoal-light mt-4 flex items-center justify-center gap-2" data-id="element-50">
            <svg className="w-4 h-4 text-sage" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-51">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-52" />
            </svg>
            Pago 100% seguro. Acceso instantáneo.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="w-full max-w-2xl mx-auto mb-12 relative" data-id="element-53">
          <div className="absolute inset-0 bg-sage rounded-2xl transform rotate-2 opacity-10" data-id="element-54"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2cTLuGtwGUaHhBn7VkQ5rT/Smiling_woman_with_ebook_on_menopause.png" alt="Mujer sonriente sosteniendo el ebook Menopausia Sin Niebla" className="w-full h-auto rounded-2xl shadow-2xl relative z-10 object-cover border-4 border-white" data-id="element-55" />
        </FadeIn>
      </div>
    </section>;
}